import React, { Fragment } from 'react'
import { DIALOG_MENU_PROPS } from '../ravenV5Theme'
import { Button } from '@atd/rui-base.mui.button'
import ResponsiveDialog from '../commonComponents/responsiveDialog'
import { DialogActions } from '@atd/rui-base.mui.dialog-actions'
import { DialogContent } from '@atd/rui-base.mui.dialog-content'
import DialogHeader from '../commonComponents/dialogHeader'
import { FormControl } from '@atd/rui-base.mui.form-control'
import { Select } from '@atd/rui-base.mui.select'
import ValidatedTextField from '../commonComponents/validatedTextField'
import PropTypes from 'prop-types'

import { areaMenuItems } from '../commonComponents/unitMenuItems'
import { checkFieldLimits } from '../lib/ddiUnits'
import { emptyForNull } from '../lib/formData'

class FieldEdit extends React.Component {
    static propTypes = {
        data: PropTypes.object,
    }

    static defaultProps = {
        data: {
            id: -1,
            growerId: -1,
            farmId: -1,
            name: '',
            section: '',
            township: '',
            county: '',
            region: '',
            area: 0,
            displayArea: '0',
            areaDisplayUnit: 'ac',
            cropType: '',
            cropVariety: '',
            comments: '',
        },
        disabled: false,
    }

    state = {
        open: true,
        ...emptyForNull(this.props.data),
        errorMessage: '',
    }

    handleChange = (event) => {
        const formData = {...this.state}
        formData[event.target.name] = event.target.value
        this.setState(formData)
    }
    handleAreaDisplayUnit = (event, index, value) => {
        this.setState({areaDisplayUnit: value})
    }

    // eslint-disable-next-line
    handleSubmit = () => {
        if (!this.state.name || this.state.name.length > 32 ||
            (this.state.section && this.state.section.length > 32) ||
            (this.state.township && this.state.township.length > 32) ||
            (this.state.region && this.state.region.length > 32) ||
            (this.state.county && this.state.county.length > 32) ||
            (this.state.cropType && this.state.cropType.length > 32) ||
            (this.state.cropVariety && this.state.cropVariety.length > 32) ||
            (this.state.cropVariety && !this.state.cropType) ||
            (this.state.displayArea && this.state.displayArea != 0 && checkFieldLimits(this.state.displayArea, this.state.areaDisplayUnit)) ||
            (!this.state.areaDisplayUnit) ||
            (this.state.comments && this.state.comments.length > 330)
        ) {
            this.setState({errorMessage: 'Invalid Data'})
        }
        else {
            this.requestClose(() => this.props.onSubmit({ ...this.state }))
        }
    }
    requestClose = (onComplete) => {
        this.exitCallback = onComplete
        this.setState({open: false})
    }
    handleCancel = () => {
        this.requestClose(this.props.onCancel)
        this.setState({
            ...emptyForNull(this.props.data),
            errorMessage: '',
        })
    }

    renderActions = () => {
        if (this.props.disabled) {
            return [
                <Button key="close" variant="contained"
                    color="primary"
                    onClick={this.handleSubmit}
                    name="closeButton">{'Close'}</Button>,
            ]
        }

        return [
            <div key="error" style={{display: 'inline-block', color: 'red'}}>{this.state.errorMessage}</div>,
            <Button key="cancel" variant="text"
                color="primary"
                onClick={this.handleCancel}
                name="cancelButton">Cancel</Button>,
            <Button key="save" variant="contained"
                startIcon={<img className="standardIcon" src={`${process.env.PUBLIC_URL}/images/jobIcons/Job_SaveWhite.svg`}/>}
                color="primary"
                onClick={this.handleSubmit}
                name="saveButton">{'Save'}</Button>,
        ]
    }

    renderFieldLocation = () => {
        return <Fragment>
            <ValidatedTextField
                disabled={this.props.disabled}
                label="Field Name"
                fullWidth={true}
                onChange={this.handleChange}
                value={this.state.name}
                name="name"
                errorText={(!this.state.name && 'Required Field') || (this.state.name.length > 32 && 'Max Length 32')}
            />
            <ValidatedTextField
                disabled={this.props.disabled}
                label="Section"
                fullWidth={true}
                onChange={this.handleChange}
                value={this.state.section}
                name="section"
                errorText={this.state.section && this.state.section.length > 32 && 'Max Length 32'}
            />
            <ValidatedTextField
                disabled={this.props.disabled}
                label="Township"
                fullWidth={true}
                onChange={this.handleChange}
                value={this.state.township}
                name="township"
                errorText={this.state.township && this.state.township.length > 32 && 'Max Length 32'}
            />
            <ValidatedTextField
                disabled={this.props.disabled}
                label="County"
                fullWidth={true}
                onChange={this.handleChange}
                value={this.state.county}
                name="county"
                errorText={this.state.county && this.state.county.length > 32 && 'Max Length 32'}
            />
            <ValidatedTextField
                disabled={this.props.disabled}
                label="State"
                fullWidth={true}
                onChange={this.handleChange}
                value={this.state.region}
                name="region"
                errorText={this.state.region && this.state.region.length > 32 && 'Max Length 32'}
            />
        </Fragment>
    }

    renderCropFields = () => {
        return <Fragment>
            <div style={{display: 'flex', alignItems: 'baseline', paddingTop: '16px'}}>
                <ValidatedTextField
                    disabled={this.props.disabled}
                    label="Area"
                    margin="none"
                    onChange={this.handleChange}
                    value={this.state.displayArea}
                    name="displayArea"
                    errorText={this.state.displayArea && this.state.displayArea != 0 && checkFieldLimits(this.state.displayArea, this.state.areaDisplayUnit)}
                    style={{marginRight: '10px', flexGrow: 2, flexShrink: 0.5}}
                />
                <FormControl
                    variant="standard"
                    className="unitSelectionInline"
                    margin="none"
                    disabled={this.props.disabled}
                    error={!this.state.areaDisplayUnit}
                >
                    <Select
                        MenuProps={DIALOG_MENU_PROPS}
                        value={this.state.areaDisplayUnit || ''}
                        onChange={(event) => this.handleAreaDisplayUnit(event, null, event.target.value)}
                        name="areaDisplayUnit"
                    >
                        {areaMenuItems}
                    </Select>
                </FormControl>
            </div>
            <ValidatedTextField
                disabled={this.props.disabled}
                label="Crop Type"
                fullWidth={true}
                placeholder="Ex: Wheat"
                onChange={this.handleChange}
                value={this.state.cropType}
                name="cropType"
                errorText={this.state.cropType && this.state.cropType.length > 32 && 'Max Length 32'}
            />
            <ValidatedTextField
                disabled={this.props.disabled || !this.state.cropType}
                label="Crop Variety"
                fullWidth={true}
                placeholder="Ex: Ritmo B"
                onChange={this.handleChange}
                value={this.state.cropVariety}
                name="cropVariety"
                errorText={
                    (this.state.cropVariety && !this.state.cropType && 'Crop Type Required') ||
                    (this.state.cropVariety && this.state.cropVariety.length > 32 && 'Max Length 32')
                }
            />
        </Fragment>
    }

    render() {
        const editActions = this.renderActions()

        return (
            <ResponsiveDialog
                open={this.state.open}
                onClose={(_, reason) => { if (reason !== 'backdropClick') this.handleCancel() }}
                TransitionProps={{onExited: () => { if (this.exitCallback) this.exitCallback() }}}
                PaperProps={{className: 'wodialog'}}
                fullWidth
            >
                <DialogHeader onClose={this.handleCancel}>Field Information</DialogHeader>
                <DialogContent>
                    {this.renderFieldLocation()}
                    {this.renderCropFields()}
                    <h3>Comments</h3>
                    <ValidatedTextField
                        disabled={this.props.disabled}
                        fullWidth={true}
                        onChange={this.handleChange}
                        value={this.state.comments}
                        multiline={true}
                        name="comments"
                        errorText={this.state.comments && this.state.comments.length > 330 && 'Max Length 330'}
                    />
                </DialogContent>
                <DialogActions>{editActions}</DialogActions>
            </ResponsiveDialog>
        )
    }
}
export default FieldEdit
